// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"433cff2b5a56a14722df","293":"02efcaf21670c6ccf454"}[chunkId] + ".js";
};